<template>
  <div id="form-fields" class="lg:col-span-2">
    <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5">
      <!-- questão -->
      <div class="col-span-5">
        <BaseInput
          type="text"
          name="question.title"
          v-model="store.question.title"
          label="Questão"
          :info="'Questão'"
          :required-field="false"
          :activeDefault="true"
        >
          <template #append>
            <CleanInputButton @click="store.question.title = null" />
          </template>
        </BaseInput>
        <span name="question.title" class="text-red-600 text-sm" />
      </div>

      <!-- separator -->
      <div class="col-span-5">
        <div class="inline-flex items-center justify-center w-full">
          <hr class="w-64 h-px my-2 bg-gray-300 border-0" />
          <span
            class="absolute px-3 font-medium -translate-x-1/2 bg-white left-1/2"
          >
            opções
          </span>
        </div>
      </div>

      <div class="md:col-span-5">
        <div class="grid gap-4 gap-y-2 text-sm grid-cols-5">
          <!-- option -->
          <div class="md:col-span-5">
            <BaseInput
              type="text"
              name="question.options.text"
              v-model="store.question.options.text"
              :info="'Alternativa'"
              label="Informe a alternativa"
              :required-field="false"
              :activeDefault="true"
            >
            </BaseInput>
            <span name="question.options.text" class="text-red-600 text-sm" />
          </div>

          <!-- is_correct -->
          <div class="md:col-span-2">
            <div class="md:col-span-2 mt-1">
              <label
                class="text-left flex pl-1 text-xs text-[#2b3038]"
                for="form.type"
              >
                Correta? <a class="text-red-600 ml-1">*</a>
              </label>
              <div class="h-10 flex rounded items-center">
                <SimpleSelect
                  class="px-1 py-2 appearance-none outline-none text-gray-800 w-full bg-transparent text-center"
                  :key="clearOnSelected"
                  :data="yesOrNo"
                  @selected-data="
                    (val) => (store.question.options.is_correct = val.value)
                  "
                />
              </div>
            </div>

            <span name="afastamento_form.type" class="text-red-600 text-sm" />
          </div>

          <!-- Botão de Adicionar -->
          <div class="col-span-1">
            <div class="h-full">
              <button
                title="Adicionar"
                @click="addOption"
                class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center"
              >
                <component class="w-8 h-8" :is="PhPlus"></component>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="md:col-span-5" v-if="store.question.options">
        <div class="mt-1 w-full max-h-[20vh] overflow-auto">
          <h3
            class="text-lg font-semibold text-start sticky top-0 bg-white p-1"
          >
            Opções: {{ store.question.options?.length }}
          </h3>

          <ul class="flex flex-wrap">
            <li
              v-for="(question, index) in store.question.options"
              :key="index"
              class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
            >
              <label>
                <!-- opção -->
                <label class="font-bold uppercase">
                  <small class="text-gray-400 font-normal lowercase">
                    opção:
                  </small>
                  <!-- Alternativa da pergunta -->
                  {{
                    question.text?.length > 20
                      ? question.text.slice(0, 20).concat("...")
                      : question.text
                  }}
                  <br />
                </label>

                <!-- is_true -->
                <label
                  class="font-bold uppercase"
                  :class="[
                    question.is_correct ? 'text-green-400' : 'text-red-400',
                  ]"
                >
                  <small class="text-gray-400 font-normal lowercase">
                    correta:
                  </small>
                  {{ question.is_correct == true ? "SIM" : "NÃO" }}
                  <br />
                </label>
              </label>

              <!-- remover -->
              <button
                @click="removeIntegrante(index, question.id)"
                class="text-red-500 hover:text-red-700 flex px-1"
              >
                <component
                  :is="PhX"
                  class="w-5 h-5 rounded-full bg-white p-0.5"
                ></component>
              </button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseInput from '@/components/Inputs/BaseInput.vue'
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import { dataExtinguisher } from '../../store'
import CleanInputButton from '../../utils/CleanInputButton.vue'
import { yesOrNo } from '@/modules/events/lookups/form'
import { PhPlus, PhX } from '@phosphor-icons/vue'
import { ref, onMounted } from 'vue'

const store = dataExtinguisher.state
const clearOnSelected = ref(0)
const qId = ref(0)

function addOption () {
  const text = store.question.options.text
  const is_correct = store.question.options.is_correct
  qId.value++

  if (!text || is_correct == null) {
    alert('Preencha todos os campos')
    return
  }

  dataExtinguisher.commit('ADD_QUESTIONS', {
    order: qId.value,
    text,
    is_correct
  })

  clearOnSelected.value++
}

function removeIntegrante (idF) {
  store.question.options.splice(idF, 1)
}

onMounted(() => {
  qId.value = 0
})

</script>
